"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const app_service_1 = require("../../commons/app.service");
const router_1 = require("@angular/router");
const material_1 = require("@angular/material");
const core_2 = require("@ngx-translate/core");
const rxjs_1 = require("rxjs");
const _4d_mapper_1 = require("4d-mapper");
const vasat_1 = require("vasat");
const _4d_mapper_2 = require("4d-mapper");
const AppBaseComponent_1 = require("../../commons/AppBaseComponent");
const application_events_service_1 = require("../../xs/services/events/application-events.service");
class ProjectEditorComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(dialogRef, data, fourD, service, r, sn, ar, t, d, applicationEvents) {
        super(service, r, sn, d, applicationEvents);
        this.dialogRef = dialogRef;
        this.data = data;
        this.fourD = fourD;
        this.service = service;
        this.t = t;
        this.subs = [];
        this.setCurrent(data.project);
    }
    setCurrent(p) {
        this.currentProject = new _4d_mapper_2.Project(this.fourD.V);
        this.currentProject = Object.assign(this.currentProject, p);
    }
    saveCurrent() {
        this.currentProject.saveObservable().subscribe(s => {
            this.dialogRef.close(this.currentProject);
            this.openSnackBarInfo("GENERIC.SAVED");
        }, e => this.openSnackBarError(e.message));
    }
    deleteCurrent() {
        this.currentProject.destroyObservable().subscribe(s => {
            this.currentProject['nuked'] = true;
            this.dialogRef.close(this.currentProject);
            this.openSnackBarInfo("GENERIC.DELETED");
        }, e => this.openSnackBarError(e.message));
    }
    browseFiles() {
        this.openDialogWithMode('folder', "PROJECT.DIALOG.ADD_FOLDER_TITLE", "PROJECT.DIALOG.ADD_FOLDER_TEXT").subscribe(dest => {
            this.currentProject.folders.addObserveable(dest).subscribe(s => this.openSnackBarSuccess("GENERIC.SAVED", null), e => this.openSnackBarError(e.message, null));
        }, e => this.openSnackBarError(e.message, null));
    }
    browseTransformForFolder(tt) {
        this.openDialogWithMode('folder', "PROJECT.DIALOG.ADD_FOLDER_TITLE", "PROJECT.DIALOG.ADD_FOLDER_TEXT").subscribe(dest => {
            if (dest) {
                var filter = this.fourD.transformTypes.filter(t => t.uid == tt.metaType);
                if (tt.metaType == 'photo-dzi')
                    filter.push(this.fourD.transformTypes.find(t => t.uid == 'thumb'));
                this.currentProject.addTransformsFromFolder(dest, filter).subscribe(s => {
                    this.openSnackBarSuccess(s + ' FILE_LIST.DIALOG.ITEMS_ADDED');
                    tt.refresh();
                }, e => this.openSnackBarError(e));
            }
        }, e => this.openSnackBarError(e.message, null));
    }
    removeAll(tt) {
        this.t.get('TYPES.' + tt.metaType).subscribe(s => this.openDialogWithMeta({ type: s }, "PROJECTS.DELETE_TITLE", "PROJECTS.DELETE_MSG", "GENERIC.YES", "GENERIC.NO").subscribe(s => {
            if (s) {
                var filter = this.fourD.transformTypes.filter(t => t.uid == tt.metaType);
                if (tt.metaType == 'photo-dzi')
                    filter.push(this.fourD.transformTypes.find(t => t.uid == 'thumb'));
                this.currentProject.removeAllTransforms(filter).subscribe(s => {
                    this.openSnackBarSuccess(s + ' FILE_LIST.DIALOG.ITEMS_ADDED');
                    tt.refresh();
                }, e => this.openSnackBarError(e));
            }
        }, e => this.openSnackBarError("FILE_LIST.DELETE.ERROR", null, { msg: e.message })));
    }
    browseTT(obj) {
        this.openDialogWithModeAndFilter('file', obj.metaType, "PROJECT.DIALOG.ADD_TRANSFORM_TITLE", "PROJECT.DIALOG.ADD_TRANSFORM_TEXT").subscribe(dest => {
            if (dest)
                rxjs_1.forkJoin(dest.map(d => this.currentProject.transforms.addObserveable(d)))
                    .subscribe(s => {
                    this.openSnackBarSuccess("GENERIC.SAVED", null);
                    obj.refresh();
                }, e => this.openSnackBarError(e.message, null));
        }, e => this.openSnackBarError(e.message, null));
    }
    /*
      addACL(){
        this.openDialogWithMode('user','zz','zz').subscribe(s => {
          if(s){
           var p = new ProjectACL(this.service.V)
            p.user = s
            p.project = this.currentProject
            p.saveObservable().subscribe(
              s => this.acl.push(p)
            ,
              e => this.openSnackBarError(e.message)
            )
          }
        })
    
      }
      rmACL(p:ProjectACL){
        p.destroyObservable().subscribe(s =>
          this.acl = this.acl.filter(a => a != p)
        ,
          e => this.openSnackBarError(e.message)
        )
      }*/
    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }
}
exports.ProjectEditorComponent = ProjectEditorComponent;
class ProjectItem {
    constructor(fourD) {
        this.fourD = fourD;
        this.onAdd = new core_1.EventEmitter();
        this.onDel = new core_1.EventEmitter();
        this.onAddFolder = new core_1.EventEmitter();
    }
    ngOnInit() {
        if (this.metaType == 'photo-dzi') {
            var v = "";
            this.fourD.transformTypes.filter(t => t.uid == this.metaType || t.uid == 'thumb').map(t => v += t.id + '|');
            this.query = new vasat_1.ToManyList(_4d_mapper_2.Transform, this.project, 'transforms')
                .limit(5)
                .equals('transformType', v);
        }
        else
            this.query = new vasat_1.ToManyList(_4d_mapper_2.Transform, this.project, 'transforms')
                .limit(5)
                .equals('transformType', this.fourD.transformTypes.find(t => t.uid == this.metaType));
    }
    refresh() {
        this.query.queryObservable().subscribe();
    }
}
exports.ProjectItem = ProjectItem;
/*
@Component({

  selector:'[proj-acl-item]',
  template:`
        <td>{{ item.username[0] }}</td>
        <td *ngFor="let cur of perms"  class="text-center">
          <button mat-icon-button (click)="setACL(cur[0],cur[1])">
            <fa-icon icon="eye" *ngIf="cur[0][cur[1]] == READ || cur[0][cur[1]] === true"  [matTooltip]="'GENERIC.READ_ONLY' | translate"></fa-icon >
            <fa-icon  icon="pencil" *ngIf="cur[0][cur[1]] == READ_WRITE"  [matTooltip]="'GENERIC.READ_WRITE' | translate"> </fa-icon >
            <fa-icon  icon="ban" class=" text-danger" *ngIf="!cur[0][cur[1]]" [matTooltip]="'GENERIC.NO_ACCESS' | translate"></fa-icon >
          </button>
        </td>
        <td class="text-right"> <fa-icon  icon="times" (click)="onDelete.emit(item)"></fa-icon>  </td>
`
})
export class ProjectACLItem {

  @Input()
  item:ProjectACL

  @Output()
  onDelete = new EventEmitter()

  @Output()
  onUpdate = new EventEmitter()

  types = {}


  perms = []

  READ_WRITE:Role
  READ:Role
  constructor(private fourD:FourDService) {
    this.READ = fourD.roles.find(r => r.uid == 'read_api')
    this.READ_WRITE = fourD.roles.find(r => r.uid == 'full_api')
  }
  ngOnInit(){
    this.item['transforms'].forEach(t => this.types[t] = true)
    this.perms = [
      [this.types,'photo-dzi'],
      [this.types,'three-d-tiles'],
      [this.types,'terrain'],
      [this.types,'tms'],
      [this.item,'workflowAccess'],
      [this.item,'folderAccess'],
      [this.item,'annotationAccess'],
    ]
  }
  setACL(obj:any, key:string){
    if(obj == this.types){
      var tt = this.fourD.transformTypes.find(t => t.uid == key)
      if(tt){
        var obs:Observable<any>
        if(this.types[key] != true)
          obs = this.item.transformAccess.addObserveable(tt)
        else
          obs = this.item.transformAccess.removeObservable(tt)

        obs.subscribe(s => {
          this.types[key] = !this.types[key];
          this.onUpdate.emit(this.item)
        },
          e => console.log(e)
        )
      }
    }
    if(obj == this.item){
      var cur  = this.item[key]
      if(!cur){
        this.item[key] = this.READ
        this.item.saveObservable().subscribe()
      }
      else if(cur == this.READ){
        this.item[key] = this.READ_WRITE
        this.item.saveObservable().subscribe()
      }
      else{
        this.item[key] = null
        this.item.saveObservable().subscribe()

      }
    }
  }

}

*/
